export const APP_VERSION = '__APP_VERSION__';
const VERSION_STORAGE_KEY = 'nrz_app_version';
const VERSION_URL = '/version.json';

// Obtenir la version stockée localement
function getStoredVersion() {
    return localStorage.getItem(VERSION_STORAGE_KEY);
}

// Initialiser ou mettre à jour la version stockée
export async function initializeAppVersion() {
    try {
        console.log('Initialisation de la version...');
        // Récupérer la version actuelle du serveur
        const response = await fetch(VERSION_URL + '?t=' + Date.now(), {
            headers: {
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache'
            }
        });
        
        if (!response.ok) {
            throw new Error(`Erreur HTTP: ${response.status}`);
        }
        
        const data = await response.json();
        console.log('Version du serveur:', data);
        
        // Stocker la version initiale si elle n'existe pas encore
        const currentVersion = getStoredVersion();
        console.log('Version stockée:', currentVersion);
        
        if (!currentVersion && data.version) {
            localStorage.setItem(VERSION_STORAGE_KEY, data.version);
            console.log('Nouvelle version stockée:', data.version);
        }
        return data.version;
    } catch (error) {
        console.error('Erreur lors de l\'initialisation de la version:', error);
    }
    return null;
}

// Mettre à jour la version stockée
export function updateStoredVersion(version) {
    console.log('Mise à jour de la version stockée:', version);
    localStorage.setItem(VERSION_STORAGE_KEY, version);
}

export async function checkForUpdates(updateCallback) {
    try {
        console.log('Vérification des mises à jour...');
        const response = await fetch(VERSION_URL + '?t=' + Date.now(), {
            headers: {
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache'
            }
        });
        
        if (!response.ok) {
            throw new Error(`Erreur HTTP: ${response.status}`);
        }

        const data = await response.json();
        console.log('Version du serveur reçue:', data);
        
        const currentVersion = getStoredVersion();
        console.log('Version actuelle:', currentVersion);

        // Si pas de version stockée, initialiser avec la version actuelle
        if (!currentVersion && data.version) {
            console.log('Pas de version stockée, initialisation...');
            updateStoredVersion(data.version);
            return false;
        }

        // Comparer avec la version stockée
        if (data.version && data.version !== currentVersion) {
            console.log('Nouvelle version disponible:', data.version, 'Version actuelle:', currentVersion);
            updateCallback(data);
            return true;
        }
        
        console.log('Pas de nouvelle version disponible');
        return false;
    } catch (error) {
        console.error('Erreur lors de la vérification des mises à jour:', error);
        return false;
    }
}
